
import { useState } from 'react';
import { LoginForm } from "../components/LoginForm";
import { Layout } from "../components/Layout";
import VerifyOTP from "@/components/Modals/verifyLoginOTP";
import { useLocation } from 'react-router-dom';
export const Login = () => {
  const [isOpen, setIsopen] = useState(false);
  const [email, setEmail] = useState('')
  const handleClose = () => {
    setIsopen(false);
  };
  const location = useLocation();
const from = location.state?.from || { pathname: "/app" };
  console.log("from",from)
  

  return (
    <Layout title="Log in to your account">
      <LoginForm onSuccess={(email) => { setIsopen(true); setEmail(email) }} />
      <VerifyOTP
        open={isOpen}
        onClose={handleClose}
        email={email}
        redirectPath={from}
      />
    </Layout>
  );
};
